'use client';

import React from 'react';
import { motion } from 'motion/react';
import Image from 'next/image';

import { ModalForm } from '@/components/ModalForm';
import { Button } from '@ui/button';

import { mapBlocksToData } from '@/utilities/mapGlobalWidgetBlocksToData';
import { cn } from '@/utilities/cn';
import type { GlobalWidget } from '@/payload-types';
import medicalKit from './assets/medicalKit.svg';
import heart from './assets/heart.svg';
import man from './assets/man.svg';
import head from './assets/head.svg';

export function Departments({ blocks }: GlobalWidget) {
  const { title, description, departments } = mapBlocksToData(blocks, {
    title: 'titleBlock',
    description: 'stringBlock',
    departments: 'features',
  } as const);

  return (
    <section className="v-margin" data-name="Departments">
      <motion.div
        className="container"
        // initial="initial"
        // whileInView="inView"
        // viewport={{ amount: 0.5, once: true }}
      >
        <div className="corners relative overflow-hidden bg-gray-700">
          <div className="z-10 min-h-[528px] px-8 py-[85px] text-center md:min-h-[464px] md:px-4 md:py-[55px]">
            <h2 className="h2 md:h4 mb-2.5 md:mb-2">{title}</h2>
            <p className="h5 md:h6 mb-[53px] md:mb-[29px]">{description}</p>
            <ModalForm
              toggleStyle="mx-auto"
              toggle={<Button>Заказать звонок</Button>}
            />
          </div>

          <div className="text-blue h5 absolute bottom-0 left-1/2 w-[1376px] -translate-x-1/2 md:w-[343px]">
            {departments.map((i, idx) => (
              <div
                className={cn(
                  'flex-center border-blue absolute h-14 rounded-full border px-8 md:h-10 md:px-3',
                  idx === 0 &&
                    'bottom-[84px] left-[121px] rotate-[14.29deg] md:bottom-[175px] md:left-0',
                  idx === 1 &&
                    'bottom-[28px] left-[250px] rotate-[-17.08deg] md:bottom-[71px] md:left-[-37px] md:rotate-[-63.65deg]',
                  idx === 2 &&
                    'bottom-[35px] left-[522px] rotate-[26.52deg] md:bottom-[25px] md:left-[58px]',
                  idx === 3 &&
                    'bottom-[62px] left-[695px] rotate-[-9.26deg] md:bottom-[72px] md:left-[125px]',
                  idx === 4 &&
                    'bottom-[6px] left-[810px] rotate-[4.29deg] md:bottom-[17px] md:left-[184px] md:rotate-[16.56deg]',
                  idx === 5 &&
                    'bottom-[66px] left-[973px] rotate-[33.76deg] md:bottom-[135px] md:left-[135px]',
                )}
                key={i.id}
              >
                {i.title}
              </div>
            ))}

            <div className="absolute bottom-0 left-[170px] md:bottom-[127px] md:left-0 md:w-[59px]">
              <Image src={medicalKit} alt="medical-kit" />
            </div>
            <div className="absolute bottom-0 left-[473px] md:left-[56px] md:w-12">
              <Image src={heart} alt="heart" />
            </div>
            <div className="absolute bottom-[81px] left-[612px] md:bottom-[106px] md:left-[131px] md:w-[72px]">
              <Image src={man} alt="man" />
            </div>
            <div className="absolute bottom-[56px] left-[945px] md:bottom-[49px] md:left-[267px] md:w-12">
              <Image src={head} alt="head" />
            </div>
          </div>
        </div>
      </motion.div>
    </section>
  );
}
